import { useId, useLayoutEffect } from "react";
import { clearBottomRightExclusion, setBottomRightExclusion } from "./bottomRightExclusion";

/** Reserve a right-edge rail so Franklin's corner surfaces clear it. */
export function useBottomRightExclusion(source: string, width: number, active = true): void {
  const instanceId = useId();
  const key = `${source}:${instanceId}`;

  useLayoutEffect(() => {
    if (!active) return;
    setBottomRightExclusion(key, width);
    return () => clearBottomRightExclusion(key);
  }, [active, key, width]);
}
